import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Crown } from "lucide-react";
import { ProfileHeaderProps } from "./types";
import { ProfileStats } from "./shared/ProfileStats";
import { ProfileActions } from "./shared/ProfileActions";
import { ProfileInfo } from "./shared/ProfileInfo";

export const ProfileMobileHeader = ({
  profile,
  subscription,
  isOwnProfile,
  isVisitorView,
  setIsVisitorView,
  setShowEditDialog,
}: ProfileHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">{profile?.username || 'Profile'}</h2>
        {subscription?.tier === 'premium' && (
          <Badge className="bg-amber-500 text-white">
            <Crown className="h-4 w-4 mr-1" />
            Premium
          </Badge>
        )}
      </div>
      
      <div className="flex items-center gap-8">
        <Avatar className="h-20 w-20 rounded-lg">
          <AvatarImage src={profile?.avatar_url} className="object-cover" />
          <AvatarFallback className="rounded-lg">{profile?.full_name?.charAt(0) || '?'}</AvatarFallback>
        </Avatar>
        
        <div className="flex justify-around flex-1">
          <div className="text-center">
            <div className="font-bold">{profile?.portfolios?.length || 0}</div>
            <div className="text-sm text-muted-foreground">Projects</div>
          </div>
          <div className="text-center">
            <div className="font-bold">0</div>
            <div className="text-sm text-muted-foreground">Endorsements</div>
          </div>
          <div className="text-center">
            <div className="font-bold">0</div>
            <div className="text-sm text-muted-foreground">Followers</div>
          </div>
        </div>
      </div>
      
      <ProfileInfo 
        fullName={profile?.full_name}
        headline={profile?.headline}
        bio={profile?.bio}
      />
      
      <ProfileActions 
        isOwnProfile={isOwnProfile}
        isVisitorView={isVisitorView}
        setIsVisitorView={setIsVisitorView}
        setShowEditDialog={setShowEditDialog}
      />
    </div>
  );
};